import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiFlexScroll = class PiFlexScroll extends Vue {
};
__decorate([
    Prop({ default: false })
], PiFlexScroll.prototype, "block", void 0);
PiFlexScroll = __decorate([
    Component({
        components: {},
    })
], PiFlexScroll);
export default PiFlexScroll;
